import { richTextToPlainText } from "./richTextHelpers";

export const buildRadiologyContext = (fields) => [
  fields.klinischeAngaben ? `Klinische Angaben: ${fields.klinischeAngaben}` : "",
  fields.fragestellung ? `Fragestellung: ${fields.fragestellung}` : "",
  fields.modalitat ? `Modalität: ${fields.modalitat}` : "",
  fields.region ? `Körperregion: ${fields.region}` : "",
  fields.geschlecht ? `Geschlecht: ${fields.geschlecht}` : "",
  `\nBefund:\n${richTextToPlainText(fields.befund)}`,
].filter(Boolean).join("\n");

export const buildAiAssistantContext = ({
  fields,
  mode,
  promptText,
  selectionText,
  selectionOnlyInstruction,
  fullBefundInstruction,
  userInstructionLabel,
}) => {
  const baseContext = buildRadiologyContext(fields);
  const trimmedSelection = String(selectionText || "").trim();
  const instructionBlock = mode === "selection" && trimmedSelection
    ? [
        "\nMarkierter Abschnitt des Befunds:",
        trimmedSelection,
        `\n${selectionOnlyInstruction}`,
      ].join("\n")
    : `\n${fullBefundInstruction}`;

  return [
    baseContext,
    instructionBlock,
    `\n${userInstructionLabel}`,
    promptText,
  ].join("\n");
};
